"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _format = require('./format');

/* The selection both patient tables share, the broadcast picker's and
 * Directory's (D-84, D-87): the header checkbox ticks the page first;
 * "Select all N matching" then selects everyone matching the search and
 * filters (isAll), and unticking after that leaves just that patient out.
 * Patients ticked one by one are picked. A search, filter or view change
 * clears it all: the search and Filters are hidden while anything is ticked
 * (D-87). */






 const NO_SELECTION = { isAll: false, leftOut: new Set(), picked: new Set() }; exports.NO_SELECTION = NO_SELECTION

 const hasAnything = (s) => s.isAll || s.picked.size > 0; exports.hasAnything = hasAnything

/* "Select all N matching": everyone matching, on top of the patients ticked
 * one by one. */
 const selectAll = (s) => ({ ...s, isAll: true, leftOut: new Set() }); exports.selectAll = selectAll

/* The header menu's "This page": just the patients shown. */
 const selectOnly = (keys) => ({ isAll: false, leftOut: new Set(), picked: new Set(keys) }); exports.selectOnly = selectOnly

/* Whether a listed row is chosen: ticked one by one, or matching a Select
 * all that didn't leave them out. */
 const isChosen = (s, key) =>
  s.picked.has(key) || (s.isAll && !s.leftOut.has(key)); exports.isChosen = isChosen

/* Ticks or unticks rows (one, a shift-click range or the page) to the same
 * state. After Select all, unticking leaves a patient out; otherwise it
 * unticks them. Past the 20,000 cap a matching row isn't covered (D-48), so
 * with isCapped ticking it picks it one by one too: those come first (review
 * F-1). */
 const setChosen = (s, keys, isOn, isCapped = false) => {
  const leftOut = new Set(s.leftOut)
  const picked = new Set(s.picked)
  keys.forEach(key => {
    if (s.isAll) {
      // A left-out patient is never also picked, so the server can't add them back.
      picked.delete(key)
      if (isOn) {
        leftOut.delete(key)
        if (isCapped) picked.add(key)
      } else leftOut.add(key)
    } else if (isOn) picked.add(key)
    else picked.delete(key)
  })
  return { ...s, leftOut, picked }
}; exports.setChosen = setChosen

/* The header checkbox over the page's selectable rows (D-84): ticked when
 * every one is chosen, part-ticked when some are. */
 const pageState = (keys, isSelected) => {
  const isChecked = keys.length > 0 && keys.every(isSelected)
  return { isChecked, isMixed: !isChecked && keys.some(isSelected) }
}; exports.pageState = pageState

/* Pressing the header checkbox ticks the page; pressed when the page is
 * ticked, it unticks the page, or ends a Select all. */
 const pressPage = (s, keys, isChecked, isCapped = false) =>
  isChecked ? (s.isAll ? exports.NO_SELECTION : exports.setChosen.call(void 0, s, keys, false)) : exports.setChosen.call(void 0, s, keys, true, isCapped); exports.pressPage = pressPage

/* The picker's request: a Select all is the table's whole search and
 * filters, in its sort, without the broadcast's recipients when they're
 * hidden, so Add covers exactly the patients the table lists. */
 const pickRequest = (s, filter, sort, isHidingAdded = false) => ({
  ...(s.isAll ? { Filter: filter, Sort: sort.sort, Desc: sort.desc } : {}),
  ...(s.isAll && isHidingAdded ? { HideAdded: true } : {}),
  ...(s.isAll && s.leftOut.size ? { LeftOut: [...s.leftOut] } : {}),
  ...(s.picked.size ? { Picked: [...s.picked] } : {}),
}); exports.pickRequest = pickRequest

/* The Patients table's request: everyone matching except the patients left
 * out, or the patients ticked. The rows ticked on top of a Select all are
 * among its matches already. */
 const selectionRequest = (s, filter, sort) => s.isAll
  ? { Filter: filter, Sort: sort.sort, Desc: sort.desc, ...(s.leftOut.size ? { LeftOut: [...s.leftOut] } : {}) }
  : { PatientKeys: [...s.picked] }; exports.selectionRequest = selectionRequest

/* What the selection bar says (the direction C frames): "50 selected on this
 * page" with "Select all N matching" to go on; "All N matching selected" and
 * how many are left out; or, past the cap, "20,000 of N selected", the
 * maximum, in the table's sort (D-48). */







// capCount: what the cap covers, 20,000 less any patients an action would
// leave out on its own (the Patients table's running archives).
 const selectionSummary = (
  s, total, pageKeys, isCapped, capCount = _format.MAX_PER_ACTION,
) => {
  if (s.isAll && isCapped) {
    return { count: `${_format.formatCount.call(void 0, Math.min(capCount, _format.MAX_PER_ACTION))} of ${_format.formatCount.call(void 0, total)} selected`, note: 'max per action, in this sort' }
  }
  if (s.isAll) {
    return { count: `All ${_format.formatCount.call(void 0, total)} matching selected`, ...(s.leftOut.size ? { note: `${_format.formatCount.call(void 0, s.leftOut.size)} left out` } : {}) }
  }
  const n = s.picked.size
  const isPage = pageKeys.length > 0 && n === pageKeys.length && pageKeys.every(key => s.picked.has(key))
  return isPage && total > n
    ? { count: `${_format.formatCount.call(void 0, n)} selected on this page`, allOf: total }
    : { count: `${_format.formatCount.call(void 0, n)} selected` }
}; exports.selectionSummary = selectionSummary
